import { Badge, Group, Text } from '@mantine/core';
import { set } from 'lodash-es';
import { marked } from 'marked';
import MandatoryMarker from '@/components/common/MandatoryMarker';
import {
  IServiceBlock,
  useBlocksActions,
} from '@/models/commercial-proposals/blocks.store';
import { TService } from '@/models/services';
import CellBase, { cellId } from '../CellBase';
import ServiceNameCellSettings from './ServiceNameCellSettings';

export default function ServiceNameCell({
  record,
  service,
  block,
  dimmed = false,
  index,
}: {
  record: TService;
  service: IServiceBlock['services'][number];
  block: IServiceBlock;
  dimmed?: boolean;
  index: number;
}) {
  const configKey = ['services', index, 'config'] as const;
  const config = service.config;
  const { update } = useBlocksActions();

  return (
    <CellBase
      id={cellId({
        blockId: block.uuid,
        serviceId: service.serviceId,
        serviceWeight: service.weight,
        suffix: 'name',
      })}
      settings={
        <ServiceNameCellSettings
          record={record}
          service={service}
          block={block}
          config={service.config}
          onChange={(config) => {
            update({
              ...set(block, configKey, config),
            });
          }}
        />
      }
    >
      <Text
        size="xs"
        m={0}
        p={0}
        c={dimmed || config.hidden ? 'dimmed' : 'inherit'}
      >
        {record.name}
      </Text>
      <Group gap={5}>
        <MandatoryMarker shown={record.isMandatory} />
        {record.renewal?.isRenewable && (
          <Badge size="xs" variant="light" color="teal">
            Renewable
          </Badge>
        )}
        {config.hidden && (
          <Badge size="xs" variant="light" color="gray">
            Hidden
          </Badge>
        )}
      </Group>
      {config.showDescription && (
        <div
          className="md"
          dangerouslySetInnerHTML={{
            __html: marked(config.customDescription, { breaks: true }),
          }}
        ></div>
      )}
    </CellBase>
  );
}
